import api from "./api";

export interface Inscricao {
  id: number;
  edital_id: number;
  edital_nome: string;
  proponente_id: number;
  proponente_nome: string;
  proponente_email: string;
  status: "pendente" | "em_analise" | "aprovado" | "reprovado";
  created_at: string;
  analisado_em?: string;
  analisado_por?: {
    id: number;
    nome: string;
  };
  observacoes?: string;
}

export interface InscricaoDetalhada extends Inscricao {
  proponente: {
    id: number;
    nome_completo: string;
    email: string;
    cpf: string;
    telefone_celular: string;
  };
  edital: {
    id: number;
    nome: string;
    data_inicio: string;
    data_fim: string;
    status: string;
  };
  dados_formulario: Record<string, unknown>;
  schema_campos: Record<
    string,
    {
      type: string;
      label: string;
      required?: boolean;
      placeholder?: string;
      maxLength?: number;
      min?: number;
      max?: number;
      default?: string | number;
      options?: string[];
    }
  >;
}

export interface ListarInscricoesParams {
  edital_id?: number;
  status?: "pendente" | "em_analise" | "aprovado" | "reprovado";
  busca_proponente?: string;
  pagina?: number;
  por_pagina?: number;
  ordem?: string;
  direcao?: "asc" | "desc";
}

export interface ListarInscricoesResponse {
  inscricoes: Inscricao[];
  paginacao: {
    pagina_atual: number;
    total_paginas: number;
    total_registros: number;
    por_pagina: number;
  };
  estatisticas: {
    total: number;
    por_status: {
      pendentes: number;
      em_analise: number;
      aprovadas: number;
      reprovadas: number;
    };
  };
}

const inscricoesService = {
  // Listar inscrições com filtros
  listar: async (
    params?: ListarInscricoesParams
  ): Promise<ListarInscricoesResponse> => {
    const response = await api.get("/api/v1/admin/inscricoes", { params });
    return response.data;
  },

  // Visualizar detalhes de uma inscrição
  buscar: async (id: number): Promise<{ inscricao: InscricaoDetalhada }> => {
    const response = await api.get(`/api/v1/admin/inscricoes/${id}`);
    return response.data;
  },

  // Colocar inscrição em análise
  colocarEmAnalise: async (
    id: number
  ): Promise<{ message: string; inscricao: Inscricao }> => {
    const response = await api.patch(
      `/api/v1/admin/inscricoes/${id}/colocar_em_analise`
    );
    return response.data;
  },

  // Aprovar inscrição
  aprovar: async (
    id: number,
    observacoes?: string
  ): Promise<{ message: string; inscricao: Inscricao }> => {
    const response = await api.patch(`/api/v1/admin/inscricoes/${id}/aprovar`, {
      observacoes,
    });
    return response.data;
  },

  // Reprovar inscrição
  reprovar: async (
    id: number,
    observacoes: string
  ): Promise<{ message: string; inscricao: Inscricao }> => {
    const response = await api.patch(
      `/api/v1/admin/inscricoes/${id}/reprovar`,
      { observacoes }
    );
    return response.data;
  },
};

export default inscricoesService;
